import { size } from 'lodash';

export default {
    buttons: {
        start: '시작하기',
        end: '활동 종료하기',
        submit: '제출하기',
        next: '다음 문제',
        result: '결과 보기',
        nextModule: '다음으로',
        selfDone: '자습 완료',
        moduleStart: '활동 시작하기',
    },
    teacher: {
        setting: '활동 설정',
        wayOfProgress: '진행 방식',
        wayOfReading: '읽기 방식',
        title: '활동 제목',
        guide: '활동 가이드',
        tooltip: `
        <span class="tooltip_list">
            <strong>선생님과</strong>
            <span>선생님과 한 문제씩 진행해요</span>
         </span>
         <span class="tooltip_list">
            <strong>자기주도</strong>
            <span>학생이 전체 문제를 자기 속도로 풀어요</span>
        </span>            
        `,

        screen: '활동 화면',
        content: ({ values }: { values: { title?: string } }) => {
            const { title } = values;
            if (title) {
                return `활동 내용 <span>${title}</span>`;
            }
            return '활동 내용';
        },
        summary: '활동 요약',
    },
    alert: {
        wrong: '앗 틀렸어요. 다시 시도해 보세요.',
        waiting: () => {
            const messages = [
                '다 했어요! 이제 잠시 기다려주세요.',
                '좋아요! 이제 잠시 기다려주세요.',
                '잘했어요! 잠시만 기다려주세요.',
            ];
            return messages[Math.floor(Math.random() * size(messages))];
        },
    },
    question: '문항',
    answerRate: '정답률',
    relation: '{relation} 관계',
    allDone: '모든 문항을 진행했어요. 활동을 종료해 주세요!',
    champion: '챔피언',
    allSelect: '모두 선택',
    students: {
        errorTooltip: '학생이 오프라인 상태예요',
        progress: {
            title: ({ values }: { values: { isOngoing: boolean } }) => {
                const { isOngoing } = values;
                return `학생별 ${isOngoing ? '현황' : '결과'}`;
            },
        },
        standby: '진행 전',
        notAttended: '미참여',
        inProgress: '진행 중',
        notCompleted: '미완료',
        completed: '완료',
    },
    modal: {
        title: '활동 종료',
        message: '활동을 종료할까요?',
    },
    state: {
        correct: '정답',
        wrong: '오답',
    },
};
